"use strict";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Environment = require('./Environment');
/**
 * JS-son grid world environment
 * @param {array} agents JS-son agents to run
 * @param {object} state Initial environment state
 * @param {object} fieldTypes Object: all field types (id: {...properties}) the environment supports
 * @param {function} stateFilter Function for filtering state that agents should receive
 * @returns {object} JS-son environment object with grid world render function
 */


function GridWorld(agents, state, fieldTypes) {
  var stateFilter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (state) {
    return state;
  };

  var renderBrowser = function renderBrowser(state, fieldTypes) {
    return [].concat('<table>', state.fields.map(function (field, index) {
      var worldSnippet = '';
      if (index % state.dimensions[0] === 0) worldSnippet += '<tr>';
      worldSnippet += fieldTypes[field].render(state, index);
      if (index % state.dimensions[0] === state.dimensions[0] - 1) worldSnippet += '</tr>';
      return worldSnippet;
    }), '</table>').join('');
  };

  var renderNode = function renderNode(state, fieldTypes) {
    return [].concat('****', state.fields.map(function (field, index) {
      var worldSnippet = '';
      if (index % state.dimensions[0] === 0) worldSnippet += '\r\n';
      worldSnippet += fieldTypes[field].render(state, index, false);
      return worldSnippet;
    }), '\r\n****').join('');
  };

  var render = function render(state, fieldTypes) {
    return typeof window === 'undefined' ? renderNode(state, fieldTypes) : renderBrowser(state, fieldTypes);
  };

  var update = function update(actions, agentId, state, fieldTypes) {
    var agentPosition = state.positions[agentId];

    if (agentPosition) {
      var fieldType = fieldTypes[state.fields[agentPosition]];
      return _objectSpread({}, state, fieldType.trigger(actions, agentId, state, agentPosition));
    } else {
      // inactive or "dead" agents may have undefined position
      return state;
    }
  };

  return new Environment(agents, state, function (actions, agentId, currentState) {
    return update(actions, agentId, state, fieldTypes);
  }, function (state) {
    return render(state, fieldTypes);
  }, stateFilter);
}

module.exports = GridWorld;